import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/quality-control-banner.png';
import '../styles/pages.css';

function QualityIndicators() {
    const [data, setData] = useState([]);
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [yearsMonths, setYearsMonths] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        // Fetch years and months from the backend
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_quality_years_months.php')
            .then(response => response.json())
            .then(data => setYearsMonths(data))
            .catch(error => console.error('Error fetching year/month data:', error));

        // Fetch the latest biomedical data on page load
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_latest_quality_controls.php')
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    setData(data);
                    setYear(data[0].year);
                    setMonth(data[0].month);
                }
            })
            .catch(error => console.error('Error fetching latest biomedical data:', error));
    }, []);

    const handleFilter = () => {
        if (!year || !month) {
            setError('Please select both year and month.');
            return;
        }
        setError('');
        // Fetch and display data based on selected year and month
        fetch(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_quality_controls.php?year=${year}&month=${month}`)
            .then(response => response.json())
            .then(data => {
                console.log(data); // Inspect the data structure
                setData(data); // Update state with fetched data
            })
            .catch(error => console.error('Error fetching biomedical data:', error));
    };

    return (
        <div>
            <Navbar />
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Quality Indicators</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Discover how Caritas Matha Hospital measures excellence 
                            <br/>
                            through detailed quality indicators.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Discover how Caritas Matha Hospital measures excellence through detailed quality indicators.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>Caritas Matha Hospital is dedicated to maintaining the highest quality standards in healthcare, ensuring exceptional patient care and safety. Our quality indicators reflect our commitment to excellence, covering key areas such as patient outcomes, safety protocols, and clinical efficiency. We rigorously monitor and evaluate our performance to continuously improve our services.</p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Quality Indicators Banner"/>
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='quality-content'>
                    <p className='page-content-heading'>
                        Setting the Standard for Healthcare Excellence 
                        <br />
                        at Caritas Matha Hospital
                    </p>
                    <br />
                    <div className='quality-details'>
                        <p>At Caritas Matha Hospital, our Quality Control Department is integral to maintaining and enhancing healthcare excellence across our facility. Comprising a dedicated team of four personnel, the department collaborates closely with department heads—both clinical and non-clinical—to uphold rigorous standards and practices.</p>
                        <br/>

                        <p>The department takes a proactive role in developing and updating manuals and Standard Operating Procedures (SOPs) for all hospital departments and services. It oversees regular performance reviews using a variety of quality indicators, analyzing trends and recommending necessary improvements to our core team. Through internal audits and facility rounds, the department ensures that Caritas Matha Hospital consistently adheres to high standards, fostering a culture of quality and safety in patient care delivery.</p>
                        <br/>
                    </div>
                </div>

                <div className='filter-section'>
                    <p className='page-heading'>Transparency in Quality</p>
                    <div>
                        <br />
                        Filter Data by:
                        <select className='filter-option' name="year" id="year" onChange={(e) => setYear(e.target.value)}>
                            <option value="">Select Year</option>
                            {/* {yearsMonths.map((item, index) => (
                                <option key={index} value={item.year}>{item.year}</option>
                            ))} */}
                            <option value="2024">2024</option>
                        </select>

                        <select className='filter-option' name="month" id="month" onChange={(e) => setMonth(e.target.value)}>
                            <option value="">Select Month</option>
                            {yearsMonths.map((item, index) => (
                                <option key={index} value={item.month}>
                                    {new Date(0, item.month - 1).toLocaleString('en-US', { month: 'long' })}
                                </option>
                            ))}
                        </select>

                        <button type="button" className="filter-button" onClick={handleFilter} >Filter Now</button>
                    </div>
                    <br/>
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}

                    {/* Displaying the selected year and month */}
                    {/* {year && month && (
                        <div style={{ margin: '20px 0' }}>
                            <h3 id="month_year">
                                {`${new Date(0, month - 1).toLocaleString('default', { month: 'long' })} ${year}`}
                            </h3>
                        </div>
                    )} */}

                    {data.length > 0 && (
                        data.map((item, index) => (
                            <div key={index}>
                                <h3 className='year_months' id="month_year">{new Date(item.month_year).toLocaleString('default', { month: 'long', year: 'numeric' })}</h3>
                                <div className="data-section">
                                    <div className="quality-data-row">
                                        <p>Average Length of Stay of Patients (In Days)</p>
                                        <h3 id="average_length">{ item.average_length }</h3>
                                    </div>

                                    <div className="quality-data-row">
                                        <p>Patient Satisfaction <br /> Index</p>
                                        <h3 id="patient_satisfaction">{ item.patient_satisfaction }</h3>
                                    </div>

                                    <div className="quality-data-row">
                                        <p>Catheter Associated Urinary <br /> Tract Infection (CAUTI) Rate</p>
                                        <h3 id="cauti">{ item.cauti }</h3>
                                    </div>

                                    <div className="quality-data-row">
                                        <p>Ventilator Associated <br /> Pneumonia (VAP) Rate</p>
                                        <h3 id="vap">{ item.vap }</h3>
                                    </div>
                                </div>
                                <div className="data-section-2">
                                    <div className="quality-data-row">
                                        <p>Central Line Associated Blood Stream Infection (CLABSI) Rate</p>
                                        <h3 id="clabsi">{ item.clabsi }</h3>
                                    </div>

                                    <div className="quality-data-row">
                                        <p>Surgical Site <br/>Infection (SSI) rate</p>
                                        <h3 id="ssi">{ item.ssi}</h3>
                                    </div>

                                    <div className="quality-data-row">
                                        <p>Incidence of Hospital Associated Pressure Ulcers After Admission</p>
                                        <h3 id="pressure_ulcers_afteradmission">{ item.pressure_ulcers_afteradmission }</h3>
                                    </div>

                                    <div className="quality-data-row">
                                        <p>Compliance to Hand Hygiene Practice by Hospital Personnel</p>
                                        <h3 id="compliance_hand_hygiene">{ item.compliance_hand_hygiene }</h3> 
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default QualityIndicators;
